import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import InsideSacredWalls from "../../component/comman/insideSacredWalls/InsideSacredWalls";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "./Transport.css";
import { Faq } from "../../component/comman/Faq/Faq";
import "./TransportMedia.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { useNavigate } from "react-router-dom";

const redIcon = new L.Icon({
  iconUrl:
    "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-red.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

export const Transport = () => {
    const navigate = useNavigate();
  const transportData = useSelector((state) => state.gallery?.transport);
  const [activeMode, setActiveMode] = useState("Bus");
    useEffect(() => {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }, []);

  const poojaHours = [
    "5.30AM",
    "6.30AM",
    "7.30AM",
    "8.00AM",
    "10.00AM",
    "11.00AM",
    "12.00AM",
  ];

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    AOS.init({ duration: 1000, once: true });
  }, []);

  const mode = transportData?.modes?.find((m) => m.type === activeMode) || {};
  const stands = mode?.stands || [];

  const center = transportData.mapCenter
    ? [transportData.mapCenter.lat, transportData.mapCenter.lng]
    : [10.7669, 79.7406];

  return (
    <div className="transport-page-main">
      <div className="transport-page">
        <h1 data-aos="fade-up">
          How to <span>reach Adhie Annan Temple</span>
        </h1>
        <p data-aos="fade-up">
          The Adhie Annan Temple is located in Katchanagaram, Tamil Nadu, and can
          be accessed via bus, train, car, or air travel. Below are the best
          connectivity options:
        </p>

        <div className="map-container">
          <div>
            <p data-aos="fade-up" style={{ marginBottom: "20px" }}>
              Click on your preferred mode of transport to view the nearest hubs.
            </p>

            <div className="mode-icons" data-aos="fade-up">
              {transportData?.modes?.map((m) => (
                <div
                  key={m.type}
                  className={`icon-box ${m.type === activeMode ? "active" : ""}`}
                  onClick={() => setActiveMode(m.type)}
                >
                  <img src={m.icon} alt={m.type} />
                  <span>{m.type}</span>
                </div>
              ))}
            </div>

            <div className="mode-details" data-aos="fade-up">
              {stands.length > 0 ? (
                stands.map((s, i) => (
                  <div className="stand-detail" key={i}>
                    {i === 0 && (
                      <h3 style={{ marginBottom: "5%", fontWeight: "400", fontSize: "22px" }}>
                        {s.heading}
                      </h3>
                    )}
                    <h3>{s.title}</h3>
                    <p><strong>Distance:</strong> {s.distance}</p>
                    <ul>
                      {s.points.map((p, j) => (
                        <li key={j}>{p}</li>
                      ))}
                    </ul>
                  </div>
                ))
              ) : (
                <p>{mode.info}</p>
              )}
            </div>
          </div>

          <div className="leaflet-map-container" data-aos="zoom-in">
            <MapContainer
              key={activeMode}
              center={center}
              zoom={12}
              scrollWheelZoom={true}
              style={{ height: "400px", width: "100%" }}
            >
              <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
              {stands.map((stand, index) => (
                <Marker
                  key={index}
                  position={[stand.lat, stand.lng]}
                  icon={redIcon}
                >
                  <Popup>
                    <strong>{stand.title}</strong>
                    <br />
                    Distance: {stand.distance}
                  </Popup>
                </Marker>
              ))}
            </MapContainer>
          </div>
        </div>
      </div>

      <div style={{ marginTop: "5%" }} data-aos="fade-up">
        <InsideSacredWalls />
      </div>

      <div className="pooja-times-section">
        <h1 data-aos="fade-up">
          <span>POOJA TIMES</span> IN ADHIE ANNAN TEMPLE
        </h1>

        <div className="pooja-content" data-aos="fade-up">
          <div className="pooja-image">
            <img src="/assets/image/transport/pooja-times.svg" alt="Pooja Aarti" />
          </div>

          <div className="pooja-text">
            <p>
              Welcome to Adhie Annan Temple, a sacred place of devotion and
              peace. Join us for daily poojas, aartis, and special rituals,
              where prayers fill the air with positivity and divine grace. Seek
              blessings from our revered deities and experience spiritual
              harmony. Whether you visit for morning darshan, evening aarti, or
              special festival celebrations, the temple welcomes you with open
              arms.
            </p>
            <p className="highlight">
              Plan your visit and be part of our sacred traditions.
            </p>

            <div className="pooja-timeline">
              {poojaHours.map((time, idx) => (
                <div key={idx} className="time-slot" data-aos="zoom-in">
                  <div>
                    <span>{time}</span>
                    <div className="dot" />
                  </div>
                </div>
              ))}
            </div>

            <button className="explore-btn" data-aos="fade-up" onClick={()=>navigate("/pooja")}>
              Explore Pooja Timings →
            </button>
          </div>
        </div>
      </div>

      <div data-aos="fade-up">
        <Faq />
      </div>
    </div>
  );
};
